import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import Snap from 'ol/interaction/Snap';
import Draw from 'ol/interaction/Draw';
import GeometryType from 'ol/geom/GeometryType';
import Feature from 'ol/Feature';
import { InteractionService } from '../services/interaction.service';
import { FormatUtils } from '../utils/format.utils';
import { MapComponent } from './map.component';
import Collection from 'ol/Collection';

@Component({
    selector: 'app-draw-interaction',
    template: ''
})
export class DrawInteractionComponent implements OnInit, OnDestroy {
    draw: Draw;
    drawEnd: Subject<Feature>;

    snap: Snap;

    @Input() type: GeometryType;
    @Input() snapping: boolean;
    @Output() onDrawEnd: EventEmitter<any> = new EventEmitter();

    constructor(
        private _map: MapComponent,
        private _interaction: InteractionService
    ) {
        this.drawEnd = new Subject();
        this.drawEnd.subscribe((olFeature: Feature) => {
            return this.handleFeature(olFeature);
        });
    }

    ngOnInit(): void {
        this.draw = this._interaction.getDrawInteraction(this.type, this.drawEnd);
        this._map.instance.addInteraction(this.draw);
        if (this.snapping) {
            this.snap = this.getSnapInteraction();
            this._map.instance.addInteraction(this.snap);
        }
    }

    ngOnDestroy(): void {
        this._map.instance.removeInteraction(this.draw);
        if (this.snapping) {
            this._map.instance.removeInteraction(this.snap);
        }
    }

    getSnapInteraction(): Snap {
        return new Snap({
            features: new Collection([])
        });
    }

    handleFeature(olFeature: Feature): void {
        if (this.snapping) {
            this.snap.addFeature(olFeature);
        }
        this.onDrawEnd.emit(FormatUtils.writeGeoJson(olFeature));
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/draw.component.ts